<template>
    <modal-dialog ref="popup">
        <div class="reward-modal">
            <a href="javascript:void(0)" class="close-modal" @click="closeModal">
                <i class="ito-icon-close modal-close"></i>
            </a>
            <h2 v-if="title">{{ title }}</h2>
            <p v-if="message">{{ message }}</p>
            <div class="btns">
                <button class="ito-btn ito-btn-default" @click="_cancel" v-if="cancelButton">{{ cancelButton }}</button>
                <button class="ito-btn ito-btn-primary" @click="_confirm" v-if="okButton">{{ okButton }}</button>
            </div>
        </div>
    </modal-dialog>
</template>

<script>
import ModalDialog from './ModalDialog.vue'
export default {
    name: "ConfirmDialogue",
    components: { ModalDialog },
    data: () => ({
        closeImg: '/images/close_btn.png',
        // Parameters that change depending on the type of dialogue
        title: undefined,
        message: undefined, // Main text content
        okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
        cancelButton: undefined, // text for cancel button

        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),
    methods: {
        show(opts = {}) {
            this.title = opts.title
            this.message = opts.message
            this.okButton = opts.okButton
            if (opts.cancelButton) {
                this.cancelButton = opts.cancelButton
            }
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User cancelled the dialogue'))
        },
        closeModal() {
            this.$refs.popup.close();
        }
    },
}
</script>

<style scoped>
.reward-modal{
    padding: 20px 60px;
}
h2 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
}

.btns {
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
    gap: 15px;
}

.close-modal {
    position: absolute;
    right: 9px;
    top: 8px;
}

.close-modal img {
    max-width: 100%;
}
</style>